/** A field's problem in orange under it, with the alert icon. */
import { AlertTriangle } from 'lucide-react';

export interface EditorFieldErrorProps {
  id: string;
  children: string;
}

export function EditorFieldError({ id, children }: EditorFieldErrorProps) {
  return (
    <div
      id={id}
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 12,
        fontWeight: 700,
        color: 'var(--nb-warn)',
      }}
    >
      <AlertTriangle size={14} aria-hidden style={{ flex: '0 0 auto' }} />
      {children}
    </div>
  );
}
